import React from 'react';

const VARIANTS = {
    default: 'bg-white/70 dark:bg-white/10 text-slate-700 dark:text-slate-200 border border-white/50 dark:border-white/10',
    solid: 'bg-slate-900 dark:bg-white text-white dark:text-slate-900',
    subtle: 'bg-slate-100/70 dark:bg-white/[0.06] text-slate-600 dark:text-slate-400 border border-slate-200/60 dark:border-white/[0.06]',
    accent: 'bg-primary-600 text-white shadow-sm shadow-primary-600/25',
};

const Badge = ({ children, variant = 'default', className = '', icon: Icon }) => (
    <span
        className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium backdrop-blur-sm ${
            VARIANTS[variant] || VARIANTS.default
        } ${className}`}
    >
        {Icon && <Icon className="w-3 h-3" />}
        {children}
    </span>
);

export default Badge;
